export default __webpack_public_path__ + "static/media/googleplay.f902960a.png";